module.exports = __webpack_public_path__ + "img/02.bfb9faec.jpg";